import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import MaintenancePage from '../components/MaintenancePage';

const STORAGE_KEY = 'acceliqaMaintenanceNotice';

type StoredMaintenanceNotice = {
    service_key?: string;
    service_name?: string;
    message?: string;
};

function readStoredNotice(): StoredMaintenanceNotice | null {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

function labelFromKey(serviceKey?: string): string | undefined {
    if (!serviceKey) {
        return undefined;
    }
    return serviceKey
        .split('_')
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
}

function ServiceMaintenancePage(): React.ReactElement {
    const { serviceKey } = useParams();
    const notice = useMemo(() => readStoredNotice(), []);
    const serviceName = notice?.service_name || labelFromKey(serviceKey);
    const message = notice?.message;

    return <MaintenancePage serviceName={serviceName} message={message} />;
}

export default ServiceMaintenancePage;
